/**
 * LISTADO DE ENDPOINTS API DE USUARIOS
 * URL Base: ${import.meta.env.VITE_API_GESTION_CASOS}
 */
const URL_API_USER = {
    // ==================== PERFIL DE USUARIO ====================
    // /**
    //  * GET /api/usuario/{id}/perfil
    //  * Obtiene el perfil completo de un usuario por su ID
    //  */
    // GET_USER_PROFILE_BY_ID: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario`,
    
    // /**
    //  * GET /api/usuario/me/perfil
    //  * Obtiene el perfil del usuario autenticado actual
    //  */
    // GET_CURRENT_USER_PROFILE: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario/me/perfil`,
    
    // /**
    //  * PUT /api/usuario/me/perfil
    //  * Actualiza el perfil del usuario autenticado
    //  */
    // UPDATE_USER_PROFILE: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario/me/perfil`,
    
    // // ==================== PREFERENCIAS ====================
    // /**
    //  * GET /api/usuario/{id}/preferencias
    //  * GET /api/usuario/me/preferencias
    //  * Obtiene las preferencias de un usuario
    //  */
    // GET_USER_PREFERENCES: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario`,
    
    // /**
    //  * PUT /api/usuario/me/preferencias
    //  * Actualiza las preferencias del usuario autenticado
    //  */
    // UPDATE_USER_PREFERENCES: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario/me/preferencias`,
    
    // // ==================== ROLES Y PERMISOS ====================
    // /**
    //  * GET /api/usuario/{id}/roles
    //  * GET /api/usuario/me/roles
    //  * Obtiene los roles asignados a un usuario
    //  */
    // GET_USER_ROLES: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario`,
    
    // /**
    //  * GET /api/roles
    //  * Obtiene todos los roles disponibles en el sistema
    //  */
    // GET_ALL_ROLES: `${import.meta.env.VITE_API_GESTION_CASOS}/api/roles`,
    
    // /**
    //  * POST /api/usuario/{id}/roles
    //  * Asigna un rol a un usuario (solo administradores)
    //  */
    // ASSIGN_USER_ROLE: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario`,
    
    // /**
    //  * DELETE /api/usuario/{id}/roles/{roleId}
    //  * Remueve un rol de un usuario (solo administradores)
    //  */
    // REMOVE_USER_ROLE: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario`,
    
    // ==================== ENTIDADES ====================
    /**
     * GET /api/Entidades/V2/GetInformacionEntidad
     * @description Obtiene los datos de la entidad a la que esta asociado un usuario
     */
    GET_USER_ENTITIES: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Entidades/V2/GetInformacionEntidad`,
    
    /**
     * GET /api/Entidades/V2/EntidadesPorIdUsuario
     * Retorna las entidades asociadas a un usuario por su ID
     * @description Datos requeridos para poblar el selector de entidades
     */
    GET_ENTITIES_BY_USER_ID: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/Entidades/V2/GetEntidadesPorIdUsuario`,
    
    // /**
    //  * DELETE /api/usuario/{id}/entidades/{entityId}
    //  * Desasocia una entidad de un usuario (solo administradores)
    //  */
    // REMOVE_USER_ENTITY: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario`,
    
    // // ==================== ESTADÍSTICAS ====================
    // /**
    //  * GET /api/usuario/{id}/estadisticas
    //  * GET /api/usuario/me/estadisticas
    //  * Obtiene estadísticas del usuario (casos, audiencias, documentos, etc.)
    //  */
    // GET_USER_STATS: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario`,
    
    // /**
    //  * GET /api/usuario/estadisticas/resumen
    //  * Obtiene estadísticas generales de todos los usuarios (solo administradores)
    //  */
    // GET_USERS_STATS_SUMMARY: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario/estadisticas/resumen`,
    
    // // ==================== SEGURIDAD ====================
    // /**
    //  * POST /api/usuario/me/cambiar-password
    //  * Cambia la contraseña del usuario autenticado
    //  */
    // CHANGE_PASSWORD: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario/me/cambiar-password`,
    
    // /**
    //  * POST /api/usuario/solicitar-reset-password
    //  * Solicita un reset de contraseña por email
    //  */
    // REQUEST_PASSWORD_RESET: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario/solicitar-reset-password`,
    
    // /**
    //  * POST /api/usuario/confirmar-reset-password
    //  * Confirma el reset de contraseña con token
    //  */
    // CONFIRM_PASSWORD_RESET: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario/confirmar-reset-password`,
    
    // /**
    //  * POST /api/usuario/verificar-password
    //  * Verifica si una contraseña es correcta (para operaciones sensibles)
    //  */
    // VERIFY_PASSWORD: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario/me/verificar-password`,
    
    // // ==================== BÚSQUEDA Y ADMINISTRACIÓN ====================
    // /**
    //  * GET /api/usuario/buscar
    //  * Busca usuarios por diferentes criterios (nombre, email, cédula, etc.)
    //  */
    // SEARCH_USERS: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario/buscar`,
    
    // /**
    //  * POST /api/usuario/verificar-existencia
    //  * Verifica si un usuario existe por email
    //  */
    // CHECK_USER_EXISTS: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario/verificar-existencia`,
    
    // /**
    //  * GET /api/usuario
    //  * Obtiene la lista de usuarios con paginación (solo administradores)
    //  */
    // GET_USERS: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario`,
    
    // /**
    //  * GET /api/usuario/{id}
    //  * Obtiene información básica de un usuario por ID
    //  */
    // GET_USER_BY_ID: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario`,
    
    // /**
    //  * POST /api/usuario
    //  * Crea un nuevo usuario (solo administradores)
    //  */
    // CREATE_USER: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario`,
    
    // /**
    //  * PUT /api/usuario/{id}
    //  * Actualiza un usuario existente (solo administradores)
    //  */
    // UPDATE_USER: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario`,
    
    // /**
    //  * PATCH /api/usuario/{id}/estado
    //  * Activa/desactiva un usuario (solo administradores)
    //  */
    // TOGGLE_USER_STATUS: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario`,
    
    // /**
    //  * DELETE /api/usuario/{id}
    //  * Elimina un usuario (solo administradores)
    //  */
    // DELETE_USER: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario`,
    
    // // ==================== HISTORIAL Y AUDITORÍA ====================
    // /**
    //  * GET /api/usuario/{id}/historial-actividad
    //  * GET /api/usuario/me/historial-actividad
    //  * Obtiene el historial de actividad del usuario
    //  */
    // GET_USER_ACTIVITY_HISTORY: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario`,
    
    // /**
    //  * GET /api/usuario/{id}/sesiones
    //  * GET /api/usuario/me/sesiones
    //  * Obtiene las sesiones activas del usuario
    //  */
    // GET_USER_SESSIONS: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario`,
    
    // /**
    //  * POST /api/usuario/me/cerrar-sesiones
    //  * Cierra todas las sesiones del usuario excepto la actual
    //  */
    // CLOSE_OTHER_SESSIONS: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario/me/cerrar-sesiones`,
    
    // // ==================== FOTO DE PERFIL ====================
    // /**
    //  * POST /api/usuario/me/foto-perfil
    //  * Sube o actualiza la foto de perfil del usuario
    //  */
    // UPLOAD_PROFILE_PHOTO: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario/me/foto-perfil`,
    
    // /**
    //  * GET /api/usuario/{id}/foto-perfil
    //  * GET /api/usuario/me/foto-perfil
    //  * Obtiene la URL de la foto de perfil del usuario
    //  */
    // GET_PROFILE_PHOTO: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario`,
    
    // /**
    //  * DELETE /api/usuario/me/foto-perfil
    //  * Elimina la foto de perfil del usuario
    //  */
    // DELETE_PROFILE_PHOTO: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario/me/foto-perfil`,
    
    // // ==================== NOTIFICACIONES ====================
    // /**
    //  * GET /api/usuario/me/notificaciones
    //  * Obtiene las notificaciones del usuario autenticado
    //  */
    // GET_USER_NOTIFICATIONS: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario/me/notificaciones`,
    
    // /**
    //  * PATCH /api/usuario/me/notificaciones/{id}/marcar-leida
    //  * Marca una notificación como leída
    //  */
    // MARK_NOTIFICATION_READ: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario/me/notificaciones`,
    
    // /**
    //  * PATCH /api/usuario/me/notificaciones/marcar-todas-leidas
    //  * Marca todas las notificaciones como leídas
    //  */
    // MARK_ALL_NOTIFICATIONS_READ: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario/me/notificaciones/marcar-todas-leidas`,
    
    // /**
    //  * DELETE /api/usuario/me/notificaciones/{id}
    //  * Elimina una notificación específica
    //  */
    // DELETE_NOTIFICATION: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario/me/notificaciones`,
    
    // // ==================== CONFIGURACIÓN 2FA ====================
    // /**
    //  * GET /api/usuario/me/2fa/estado
    //  * Obtiene el estado de la autenticación de dos factores
    //  */
    // GET_2FA_STATUS: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario/me/2fa/estado`,
    
    // /**
    //  * POST /api/usuario/me/2fa/habilitar
    //  * Habilita la autenticación de dos factores
    //  */
    // ENABLE_2FA: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario/me/2fa/habilitar`,
    
    // /**
    //  * POST /api/usuario/me/2fa/deshabilitar
    //  * Deshabilita la autenticación de dos factores
    //  */
    // DISABLE_2FA: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario/me/2fa/deshabilitar`,
    
    // /**
    //  * POST /api/usuario/me/2fa/verificar
    //  * Verifica el código de autenticación de dos factores
    //  */
    // VERIFY_2FA: `${import.meta.env.VITE_API_GESTION_CASOS}/api/usuario/me/2fa/verificar`,
};

export default URL_API_USER;


